import { motion } from 'framer-motion';

export const MobileContainer = ({ children, className = '', noPadding = false }) => {
  return (
    <div className="min-h-screen gradient-warm-bg flex justify-center">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={`w-full max-w-mobile min-h-screen bg-background relative flex flex-col shadow-card ${className}`}
        style={{ minHeight: '100dvh' }}
      >
        <div className={`flex-1 flex flex-col ${noPadding ? '' : ''}`}>
          {children}
        </div>
      </motion.div>
    </div>
  );
};
